import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowDownFilledStandard.js";
import l from "../components/PfIcon.js";
const r = (o, t) => {
  const e = {
    ...o,
    ...t.attrs
  };
  return a(l, n(e, {
    icon: d
  }), null);
};
r.displayName = "ArrowDownFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
